module.exports = __webpack_public_path__ + "static/media/invite_users.689dac35.svg";